module.exports = __webpack_public_path__ + "static/media/link.9d0b57e2.svg";